import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from "./../../Header";
import CustomerTabMenu from "./CustomerTabMenu";
import $ from "jquery";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
class DemoList extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			customers: [],
			apiUrl: this.decryptconfigdata("apiUrl"),
			studioUrl: this.decryptconfigdata("studioUrl"),
			activePage: 1,
			item_count: "",
			from_date: "",
			to_date: "",
			search: "",
			studio_id: "",
			user_id: "",
			userAuthKey: has_local_data ? localdata.user_key : "",
			isLoadMore: 1,
			Loading: 1,
			showMenu: false,
			allmuvisix: [],
			muvisixproductkey: "3D28C83C85544F0D9517DD2E7C7EEDAA",
			offset: 0,
			muviFiveCount: null,
			isMuviOne: false,
		};
		this.getCustomers = this.getCustomers.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.formdateChange = this.formdateChange.bind(this);
		this.todateChange = this.todateChange.bind(this);
		this.keywordChange = this.keywordChange.bind(this);
	}
	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}
	goToCustomerStore(email, password, studio_id) {
		if (window.confirm("Are you sure to login this store")) {
			var win = window.open(
				this.state.studioUrl +
					"/login/storeLogin" +
					"?email=" +
					email +
					"&password=" +
					password +
					"&studio_id=" +
					studio_id,
				"_blank"
			);
			win.focus();
		}
	}
	formdateChange(event) {
		this.setState({ from_date: event.target.value }, function () {
			this.getCustomers();
		});
	}
	todateChange(event) {
		this.setState({ to_date: event.target.value }, function () {
			this.getCustomers();
		});
	}

	keywordChange(event) {
		var obj = this;
		this.setState({
			search: event.target.value,
			activePage: 1,
			customers: [],
			Loading: 1,
		});
		//Delaying the function execute
		if (this.timer) {
			window.clearTimeout(this.timer);
		}
		if (obj.state.muvisixproductkey != "") {
			this.timer = window.setTimeout(() => {
				obj.muvisixCustomerSearchHandler();
			}, 500);
		} else {
			this.timer = window.setTimeout(function () {
				//Execute the function code here...
				obj.getCustomers();
			}, 500);
		}
	}

	muvisixCustomerSearchHandler = () => {
		this.setState(
			{
				Loading: 1,
			},
			() => {
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${this.state.muvisixproductkey}", type: \"Delete\", page: 0, size: 20, search : \"${this.state.search}") {page_info{total_count}, user_details {username, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source, store_key, domain_name}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((data) => {
						this.setState({
							customers: data.data.getCustomerList.user_details,
							item_count: data.data.getCustomerList.page_info.total_count,
							Loading: 0,
						});
					});
			}
		);
	};
	customer_details(studio_id, studio_name, user_id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/customerdetails/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					studio_id: findresponse.studio_id,
					user_id: findresponse.user_id,
				});
			});
	}
	loadMore(pageNumber) {
		this.setState({ isLoadMore: 0 });
		pageNumber = pageNumber + 1;
		this.setState({ activePage: pageNumber });
		fetch(
			this.state.apiUrl +
				"/adminRest/GetdeletedStores/page/" +
				pageNumber +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.customers.length == 0) {
					this.setState({
						isLoadMore: 2,
					});
				} else {
					this.setState({
						isLoadMore: 1,
					});
				}
				this.setState({
					// isLoadMore:1,
					customers: this.state.customers.concat(findresponse.customers),
					//item_count: findresponse.item_count,
				});
			});
	}
	handlePageChange(pageNumber = 1) {
		if (this.state.muvisixproductkey != "") {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				this.setState({ activePage: pageNumber, setPage: "no" });
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					dataType: "json",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${
							this.state.muvisixproductkey
						}", type: \"Delete\", page: ${pageNumber - 1}, size: 20, search : \"${
							this.state.search
						}") {page_info{total_count}, user_details {username, name, email, mobile,  created_date,account_status,  company_name, country_name, ip_address, address, product_name,    user_uuid, user_status, profile_image_url, deleted_date, app_token, onhold_period,    canceled_date, cancellation_reason, canceled_by, domain_name,  custom_cancellation_reason, created_date, free_trial_expiry_date, package_name, package_summary, package_period,account_status, source, store_key, domain_name}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((findresponse) => {
						$(document).ready(function () {
							$(".pages").removeClass("disabled");
							if (pageNumber == 1) {
								$(".first_page").addClass("disabled");
								$(".prev_page").addClass("disabled");
							}
							if (pageNumber == totalPages) {
								$(".next_page").addClass("disabled");
								$(".last_page").addClass("disabled");
							}
						});
						this.setState({
							customers: findresponse.data.getCustomerList.user_details,
							item_count: findresponse.data.getCustomerList.page_info.total_count,
							loading: 0,
							activePage: pageNumber,
							setPage: "yes",
						});
					});
			}
		} else {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				this.setState({ activePage: pageNumber, setPage: "no" });
				fetch(
					this.state.apiUrl +
						"/adminRest/GetdeletedStores/page/" +
						pageNumber +
						"/userAuthKey/" +
						this.state.userAuthKey +
						"/userId/" +
						this.state.userId,
					{
						method: "POST",
						dataType: "json",
						body: JSON.stringify(this.state),
					}
				)
					.then((Response) => Response.json())
					.then((findresponse) => {
						findresponse = this.rawjsonparse(findresponse, 1);
						$(document).ready(function () {
							$(".pages").removeClass("disabled");
							if (pageNumber == 1) {
								$(".first_page").addClass("disabled");
								$(".prev_page").addClass("disabled");
							}
							if (pageNumber == totalPages) {
								$(".next_page").addClass("disabled");
								$(".last_page").addClass("disabled");
							}
						});
						this.setState({
							customers: findresponse.customers,
							offset: findresponse.offset,
							off_count: findresponse.off_count,
							setPage: "yes",
						});
					});
			}
		}
	}

	getCustomers(page = 1) {
		fetch(
			this.state.apiUrl + "/adminRest/GetdeletedStores/page/" + page + "/userAuthKey/" + this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					customers: findresponse.customers,
					item_count: findresponse.item_count,
					muviFiveCount: findresponse.item_count,
					Loading: 0,
					offset: findresponse.offset,
					off_count: findresponse.off_count,
					setPage: "yes",
					muvisixproductkey: "",
				});
			});
	}
	loadMorecount() {
		if (this.state.item_count > 0) {
			if (this.state.item_count >= 20) {
				if (this.state.isLoadMore != 2) {
					if (this.state.isLoadMore == 1) {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="load_more" onClick={() => this.loadMore(this.state.activePage)}>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						);
					} else {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="lds-ripple">
									<div></div>
									<div></div>
								</div>
							</div>
						);
					}
				}
			}
		} else {
			return <div className="text-center">No Data Found</div>;
		}
	}

	getMuviClassicCount(type = "") {
		const customer_type = { type: type };
		fetch("https://cms.muvi.com/intranet/getMuvi5TotalCounts", {
			method: "POST",
			body: JSON.stringify(customer_type),
		})
			.then((Response) => Response.json())
			.then((data) => {
				this.setState({
					muviFiveCount: data.total_count,
				});
			});
	}

	componentDidMount() {
		//        this.getCustomers();
		this.getMuviClassicCount(4);
		var muvi_one_prod_key = { target: "3D28C83C85544F0D9517DD2E7C7EEDAA" };
		const muvi_one_product_key = Object.assign({}, muvi_one_prod_key);
		this.getMuvisixCustomer(muvi_one_product_key, 1);

		document.title = "Intranet | Deleted";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}
		$(document).ready(function () {
			document.getElementById("copyButton").addEventListener("click", copy, true);
			// event handler
			function copy(e) {
				// find target element
				var t = e.target,
					c = t.dataset.copytarget,
					inp = c ? document.querySelector(c) : null;
				// is element selectable?
				if (inp && inp.select) {
					// select text
					inp.select();
					try {
						// copy text
						document.execCommand("copy");
						inp.blur();
						// copied animation
						t.classList.add("copied");
						setTimeout(function () {
							t.classList.remove("copied");
						}, 1500);
					} catch (err) {
						alert("please press Ctrl/Cmd+C to copy");
					}
				}
			}
		});

		//         fetch(this.state.apiUrl +'/adminRest/getAllMuviSixProduct/userAuthKey/' + this.state.userAuthKey,{

		// method: 'GET',

		// }).then( Response => Response.json())
		//     .then( (data) =>{

		//     this.setState({

		//         allmuvisix: data
		//     })
		// })
		if (this.props.muvisixproductkey !== "") {
			const customer_section = { customer_section: 1 };
			fetch(this.state.apiUrl + "/RevenueRest/activeProductStatistics/userAuthKey/" + this.state.userAuthKey, {
				method: "POST",
				body: JSON.stringify(customer_section),
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.setState({
						allmuvisix: data.data,
					});
				});
		}
	}
	fetchProductByKey = (key) => {
		fetch("https://apigateway.muvi.com/customer-list", {
			method: "POST",
			dataType: "json",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				query: `{getCustomerList(product_key: "${key}", type: "Delete", page: 0, size: 20){total_count, user_details {username, name, email, mobile, company_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, created_date, deleted_date, app_token, onhold_period, canceled_date, cancellation_reason, canceled_by, custom_cancellation_reason, free_trial_expiry_date, package_name, card_last_four_digits, package_summary, package_period, package_price, total_revenue, next_subscription_date, last_transaction_amount, last_transaction_date, account_status, deleted_reason, deleted_by, plan_period, plan_price, plan_name, currency_code, source, store_key, domain_name}}}`,
			}),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				this.setState({
					customers: findresponse.data.getCustomerList.user_details,
					item_count: findresponse.data.getCustomerList.page_info.total_count,
				});
			});
	};

	getMuvisixCustomer = (event, cond = 0) => {
		if (cond == 1) {
			var prod_key = event.target;
		} else {
			const { value } = event.target;
			var prod_key = value;
		}
		this.setState({ isMuviOne: false });
		if (prod_key !== "") {
			if (prod_key == "3D28C83C85544F0D9517DD2E7C7EEDAA") {
				this.setState({ isMuviOne: true });
			}
			this.setState(
				{
					Loading: 1,
					search: "",
				},
				() => {
					this.getCustomersforSearch();
					fetch("https://apigateway.muvi.com/customer-list", {
						method: "POST",
						dataType: "json",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							query: `{getCustomerList( product_key: "${prod_key}", type: \"Delete\", page: 0, size: 20) {page_info{total_count}, user_details {username, name, email, created_date,  company_name, country_name,   ip_address,    address,    product_name,    user_uuid,    user_status, deleted_date,    app_token,    onhold_period,    canceled_date,    cancellation_reason, canceled_by,    custom_cancellation_reason, created_date, package_name,  account_status, deleted_reason,    deleted_by,    plan_period,    plan_price,    plan_name, source, store_key, domain_name}}}`,
						}),
					})
						.then((Response) => Response.json())
						.then((findresponse) => {
							this.setState({
								customers: findresponse.data.getCustomerList.user_details,
								item_count: findresponse.data.getCustomerList.page_info.total_count,
								Loading: 0,
								activePage: 1,
								setPage: "yes",
							});
						});

					this.setState({
						muvisixproductkey: prod_key,
					});
				}
			);
		} else {
			this.setState({ activePage: 1, search: "" }, () => {
				this.getCustomers(1);
			});
		}
	};

	getCustomersforSearch = (page = 1) => {
		fetch(
			this.state.apiUrl +
				"/adminRest/GetdeletedStores/page/" +
				page +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					muviFiveCount: findresponse.item_count,
				});
			});
	};

	getSourceLink(link) {
		if (link) {
			if (link.indexOf("http") !== -1) {
				var linknew = <a href={`${link}`} target="_blank">{`${link}`}</a>;
				return linknew;
			} else {
				return link;
			}
		} else {
			let na = "NA";
			return na;
		}
	}

	muviSixpagination = () => {
		if (20 * (this.state.activePage - 1 + 1) > this.state.item_count) {
			return (
				20 * (this.state.activePage - 1) + 1 + " - " + this.state.item_count + " of " + this.state.item_count
			);
		} else {
			return (
				20 * (this.state.activePage - 1) +
				1 +
				" - " +
				20 * (this.state.activePage - 1 + 1) +
				" of " +
				this.state.item_count
			);
		}
	};

	export() {
		var win = window.open(
			this.state.apiUrl +
				"/AdminRest/ExportUsers/userAuthKey/" +
				this.state.userAuthKey +
				"/user_type/deleted/search/" +
				this.state.search,
			"_self"
		);
		win.focus();
	}
	getDeleteList() {
		let hideSearchforMuvisix = "";

		hideSearchforMuvisix = (
			<div class="searchTicket mob_customer">
				<input
					type="text"
					class="form-control"
					name="customer"
					id="customer"
					value={this.state.search}
					placeholder="Search company, name or email"
					onChange={this.keywordChange}
				/>
				<button type="submit">
					<i class="fa fa-search"></i>
				</button>
			</div>
		);

		return (
			<section class="customer">
				<div id="exTab1" class="container">
					<CustomerTabMenu brecum_page="deletelist" />
					<div class="tab-content clearfix">
						<div class="tab-pane active" id="Deleted">
							<div class="row">
								<div class="col-md-5">
									<div class="row">
										<div class="col-md-7">
											<select
												className="form-control"
												value={this.muvisixproductkey}
												onChange={this.getMuvisixCustomer}
											>
												{this.state.allmuvisix.map((item, index) => {
													return item.product_key != "49F37046FCD84520895FC18A4F5BFC8B" ? (
														item.product_key == "3D28C83C85544F0D9517DD2E7C7EEDAA" ? (
															<option value={item.product_key} key={index} selected>
																{item.product_name} ({item.deleted})
															</option>
														) : (
															<option value={item.product_key} key={index}>
																{item.product_name} ({item.deleted})
															</option>
														)
													) : (
														<option value="">
															Muvi One (Classic) ({this.state.muviFiveCount})
														</option>
													);
												})}
											</select>
										</div>
									</div>
								</div>

								<div class="col-md-1"></div>

								<div class="col-md-6">{hideSearchforMuvisix}</div>
							</div>
							<div class="tickets hidden-sm">
								<ul class="tickets_head">
									<li class={this.state.muvisixproductkey !== "" ? "intra_col_10" : "intra_col_15"}>
										Company
									</li>
									<li class={this.state.muvisixproductkey !== "" ? "intra_col_10" : "intra_col_10"}>
										Name
									</li>
									{this.state.muvisixproductkey === "" || this.state.isMuviOne ? (
										<li
											class={this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_12"}
										>
											Website
										</li>
									) : (
										""
									)}
									<li class={this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_10"}>
										Country
									</li>
									<li class={this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_15"}>
										Deleted On
									</li>
									<li class={this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_12"}>
										Joined On
									</li>
									<li class={this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_11"}>
										Source
									</li>
									<li class="intra_col_15"></li>
								</ul>
								{this.state.Loading ? (
									<div>
										<div class="loader-new"></div>
									</div>
								) : (
									this.state.customers.map((data, key) => (
										<ul class="tickets_number">
											<li
												class={
													this.state.muvisixproductkey != ""
														? "intra_col_10 text-inded"
														: "intra_col_15 text-inded"
												}
											>
												{this.state.muvisixproductkey == "" ? (
													<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
														{" "}
														{data.company_name
															? data.company_name
															: data.name
															? data.name
															: "NA"}
													</Link>
												) : (
													<Link key={key} to={`/test/detail/${data.app_token}`} name={"max"}>
														{" "}
														{data.company_name
															? data.company_name
															: data.name
															? data.name
															: "NA"}
													</Link>
												)}
											</li>
											<li
												class={
													this.state.muvisixproductkey != ""
														? "intra_col_10 text-inded"
														: "intra_col_10 text-inded"
												}
											>
												{data.first_name ? data.first_name : data.name ? data.name : "NA"}
											</li>
											{this.state.muvisixproductkey == "" || this.state.isMuviOne ? (
												<li
													class={
														this.state.muvisixproductkey != ""
															? "intra_col_15 text-inded"
															: "intra_col_12 text-inded"
													}
												>
													<a
														href={`http://${data.domain ? data.domain : data.domain_name}`}
														target="_blank"
													>
														{data.domain ? data.domain : data.domain_name}
													</a>
												</li>
											) : (
												""
											)}
											<li
												class={
													this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_10"
												}
											>
												{data.country
													? data.country
													: data.country_name
													? data.country_name
													: "NA"}
											</li>
											<li class="intra_col_15">
												{data.deleted_date_change &&
												data.deleted_date_change != "" &&
												data.deleted_date_change != "00-00-00 00:00:00"
													? new Date(data.deleted_date_change).toLocaleDateString("en-US", {
															month: "short",
															day: "numeric",
															year: "numeric",
													  })
													: new Date(data.deleted_date_change).toLocaleDateString("en-US", {
															month: "short",
															day: "numeric",
															year: "numeric",
													  })}
											</li>
											<li
												class={
													this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_12"
												}
											>
												{data.created_at &&
												data.created_at != "" &&
												data.created_at != "00-00-00 00:00:00"
													? new Date(data.created_at_change).toLocaleDateString("en-US", {
															month: "short",
															day: "numeric",
															year: "numeric",
													  })
													: new Date(data.created_at_change).toLocaleDateString("en-US", {
															month: "short",
															day: "numeric",
															year: "numeric",
													  })}
											</li>
											<li
												class={
													this.state.muvisixproductkey != ""
														? "intra_col_15 text-inded"
														: "intra_col_11 text-inded"
												}
											>
												{data.source ? this.getSourceLink(data.source) : "NA"}
											</li>
											{this.state.muvisixproductkey == "" ? (
												<li
													class="intra_col_15"
													onClick={() =>
														this.customer_details(
															data.studio_id,
															data.studio_name,
															data.user_id
														)
													}
													data-toggle="modal"
													data-target="#subscriptionlink"
												>
													<a href="javascript:void(0);">Subscription Link</a>
												</li>
											) : (
												"NA"
											)}
										</ul>
									))
								)}
							</div>
						</div>
					</div>
				</div>
				<div class="customer_mob hidden-md">
					{this.state.customers.map((data, key) => (
						<div class="custmer_list_mob">
							<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
								<h4 class="list_title">{data.first_name}</h4>
							</Link>
							<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
								<div class="wrap">{data.domain}</div>
							</Link>
							{/* <div class="cus_details_mob">
             <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
             
             </div> */}
						</div>
					))}
				</div>
				{this.state.Loading ? (
					""
				) : (
					<span>
						{this.state.item_count > 0 ? (
							<div class="pagination-muvi">
								<Pagination
									itemClass={"pages"}
									itemClassFirst={"first_page"}
									itemClassPrev={"prev_page"}
									itemClassNext={"next_page"}
									itemClassLast={"last_page"}
									activePage={this.state.activePage}
									itemsCountPerPage={20}
									totalItemsCount={this.state.item_count}
									pageRangeDisplayed={5}
									onChange={this.state.setPage == "yes" ? this.handlePageChange : ""}
								/>
								<div style={{ color: "#333" }}>
									{this.state.muvisixproductkey == ""
										? this.state.offset +
										  1 +
										  " - " +
										  (this.state.offset + this.state.off_count) +
										  " of " +
										  this.state.item_count
										: this.muviSixpagination()}
								</div>
							</div>
						) : (
							<div className="text-center" style={{ color: "#333" }}>
								No Data Found
							</div>
						)}
					</span>
				)}
				{/* {this.loadMorecount()} */}
			</section>
		);
	}
	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}
		return (
			<div>
				{/* <--modal start for subscription link-!> */}
				<div class="modal fade" id="subscriptionlink" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Copy Subscription Link
								</h4>
							</div>
							<div class="modal-body">
								<input
									type="text"
									name="subscription_link"
									id="subscription_link"
									className="form-control"
									value={
										"https://www.muvi.com/signup/purchaseSubscription.html?studio=" +
										this.state.studio_id.uniqid
									}
									onChange={this.onChange}
								/>
								<input type="hidden" value={this.state.studio_id.id} name="studio_id" />
								<input type="hidden" value={this.state.user_id.id} name="user_id" />
								<br />
								<button
									type="button"
									id="copyButton"
									data-copytarget="#subscription_link"
									class="btn btn-default"
								>
									Copy
								</button>
							</div>

							<div class="modal-footer">
								<button type="button" class="btn btn-default" data-dismiss="modal">
									Close
								</button>
								{/* <button type="button" class="btn btn-default" onClick={()=> this.Savepassword(this.state.studio_id.id, this.state.user_id.id)}>Update</button> */}
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for subscription link-!> */}
				<Header brecum_name="Customer" brecum_page="Deleted" />
				<div className="right_col">{this.getDeleteList()}</div>
			</div>
		);
	}
}
export default DemoList;



// WEBPACK FOOTER //
// ./src/components/customer/DeletedStoresList.js